import { types } from 'mobx-state-tree';
import { createThunk, model, Model } from 'mst-collection';

import { Api } from '@api';
import { useRoot } from '../useRoot';
import { NotificationListModel } from './NotificationListModel';

export class Notifications extends Model({
  list: types.optional(NotificationListModel, {}),
  newCount: 0,
}) {
  get hasNewNotifications() {
    return this.newCount > 0;
  }

  get formattedNewCount() {
    return this.newCount > 9 ? '9+' : `${this.newCount}`;
  }

  decreaseNewCount() {
    this.newCount = Math.max(this.newCount - 1, 0);
  }

  setNewCount(value: number) {
    this.newCount = value;
  }

  fetchCount = createThunk(() => {
    return async function fetchCount(this: Notifications) {
      const res =
        await Api.Notifications.getCountOfNewNotifications();

      this.setNewCount(res.data.count);
    };
  });
}

export const NotificationsModel = model(Notifications);

export function useNotificationsModel() {
  const root = useRoot();

  return root.notifications;
}
